"use client";
import { getAnalytics, isSupported } from "firebase/analytics";
import { getApps, initializeApp } from "firebase/app";
import { updateUserClientId } from "./common.helpers";

export const firebaseConfig = {
  apiKey: "AIzaSyD5zmSDlAPmmjiqWA2lUG0ueRFH9dDnibA",
  authDomain: "stage-255509.firebaseapp.com",
  databaseURL: "https://stage-255509.firebaseio.com",
  projectId: "stage-255509",
  storageBucket: "stage-255509.firebasestorage.app",
  messagingSenderId: "836043892110",
  appId: "1:836043892110:web:99637ee2b80e713498b0df",
  measurementId: "G-3MRBHE1F0M",
};

export const initializeFirebaseApp = () => {
  return initializeApp(firebaseConfig);
};

export const getFirebaseApp = () => {
  return getApps().length === 0 ? initializeFirebaseApp() : getApps()[0];
};

export const getFirebaseAnalytics = async () => {
  const isFirebaseSupported = await isSupported();
  if (isFirebaseSupported) {
    const firebaseApp = getFirebaseApp();
    const analytics = getAnalytics(firebaseApp);
    window.firebaseAnalytics = analytics;

    updateUserClientId();

    return analytics;
  }
};

export const initFirebase = async () => {
  try {
    getFirebaseApp();
    return await getFirebaseAnalytics();
  } catch (error) {
    console.error("Firebase initialization failed:", error);
    return null;
  }
};
